import { useQuery } from "@tanstack/react-query";
import { reportService } from "@/services/ReportService";

export const reportKeys = {
  all: ['reports'],
  stats: () => [...reportKeys.all, 'stats'],
  userSessions: (page, searchParams, exclude) => [...reportKeys.all, 'userSessions', page, searchParams, exclude],
};

// Hook for fetching dashboard stats
export const useReportStats = (exclude = false, enabled = true) => {
  return useQuery({
    queryKey: [...reportKeys.stats(), exclude],
    queryFn: async () => {
      const response = await reportService.getStats(exclude);
      return response;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled,
  });
};

// Hook for fetching user sessions with pagination and search
export const useUserSessions = (page = 1, searchParams = {}, exclude = false) => {
  return useQuery({
    queryKey: reportKeys.userSessions(page, searchParams, exclude),
    queryFn: async () => {
      const response = await reportService.getUserSessions(page, searchParams, exclude);
      
      return {
        user_sessions: response?.user_sessions || [],
        pagination: {
          current_page: response?.pagination?.current_page || 1,
          total: response?.pagination?.total || 0,
          per_page: response?.pagination?.per_page || 10,
          last_page: response?.pagination?.last_page || 1
        }
      };
    },
    keepPreviousData: true // Keep displaying previous data while new data is fetched
  });
}; 